import { cn } from '@/shared/lib/classnames'
import { Button, ButtonProps } from '@/shared/ui/button'
import { MoveLeft } from 'lucide-react'
import { useRouter } from 'next/navigation'

export interface NavigateBackIconProps extends ButtonProps {}
export default function NavigateBackIcon({ children, className, onClick, ...props }: NavigateBackIconProps) {
  const router = useRouter()
  return (
    <Button
      size="icon"
      variant="defaultGhost"
      onClick={(e) => {
        onClick ? onClick(e) : router.back()
      }}
      className={cn('flex gap-2 w-[fit-content] p-3', className)}
      {...props}
    >
      <MoveLeft />
      {children && <p>{children}</p>}
    </Button>
  )
}
